import React from "react";
import ExperiencesComponent from "../components/ExperiencesComponent";
const Experiences = () => {
  return (
    <>
      <ExperiencesComponent />
    </>
  );
};

export default Experiences;
